import React from 'react'
import FillXAlertSvg from 'images/modules/Manage/i-circle-x-alert.svg?raw'

export { default as FillXAlertUrl } from 'images/modules/Manage/i-circle-x-alert.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: FillXAlertSvg}} />
)
